import React, { useState } from 'react';
import './Projects.css';

const Projects = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleProject = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const projects = [
    {
      title: 'Capstone Project – NHL Player Performance Tool',
      description: ' Built an AI-driven system to evaluate player performance using historical and real-time analytics',
      bullets: [
        'Implemented player comparison views, category-based rankings, statistical breakdowns and dashboards',
        'Applied BERT to classify and assess over/under-performance relative to league averages',
        'Designed interactive UI components to support scouting insights and fan data exploration',
        'Technologies: Python, Google Cloud, BERT, JavaScript, CSS, HTML, React, Node.js, Git, GitHub, MongoDB',
        {
          label: 'GitHub',
          link: 'https://github.com/ansonruan7/What-The-Puck'
        }
      ]
    },
    {
      title: 'Ongoing Living Learning Communication Website',
      description: 'Built an accessibility-focused communication tool for adults with cognitive disabilities and caregivers',
      bullets: [
        'Designed intuitive navigation, simplified user pathways, and responsive layouts for ease of use',
        'Technologies: React, Node.js, MongoDB, JavaScript, HTML, CSS, Git, GitHub',
        {
          label: 'GitHub: Please Ask (Private Permissions)',
        }
      ]
    }
  ];

  return (
    <div className="projects-container" id="projects">
      <h1 className="projects-title">Projects</h1>

      {projects.map((project, index) => (
        <div key={index} className={`project-card ${openIndex === index ? 'open' : ''}`}>
          <div className="project-header" onClick={() => toggleProject(index)}>
            <h2>{project.title}</h2>
            <span className="toggle-icon">{openIndex === index ? '−' : '+'}</span>
          </div>
          {openIndex === index && (
            <div className="project-content">
              <p>{project.description}</p>
              <ul>
                {project.bullets.map((bullet, i) => (
                  <li key={i}>
                    {typeof bullet === 'string' ? (
                      bullet.includes('Technologies') ? <strong>{bullet}</strong> : bullet
                    ) : bullet.link ? (
                      <>
                        <strong>{bullet.label}:</strong>{' '}
                        <a
                          href={bullet.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {bullet.link}
                        </a>
                      </>
                    ) : (
                      <strong>{bullet.label}:</strong>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Projects;


